import { SectionsPage } from "./SectionsPage";
import { CatalogsPage } from "./CatalogsPage";

const pages = {
  SectionsPage,
  CatalogsPage,
};
export default pages;
